import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import HeaderCard from "../Component/HeaderCard";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import CelebrationComponent from "../Component/Celebrate";
import ArrayCounter from "../Component/ArrayCounter";
import WordsTrEngCard from "../Component/WordsTrEngCard";
import WordEngCard from "../Component/WordEngCard";
// import axios from "axios";
import api from "../utils/api";

function Speaking_1() {
  const [TextValue, setTextValue] = useState(0);
  const [activeLevel, setActiveLevel] = useState("Beginner");
  const [isTeacherTurn, setIsTeacherTurn] = useState(true);
  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [similarityScore, setSimilarityScore] = useState(0);
  const [completePart, setCompletePart] = useState(false);
  const [repeatBeginnerCount, setRepeatBeginnerCount] = useState([]);
  const [repeatIntermediateCount, setRepeatIntermediateCount] = useState([]);
  const [repeatAdvancedCount, setRepeatAdvancedCount] = useState([]);
  const [taskPackage, setTaskPackage] = useState({});

  const recognitionRef = useRef(null);
  const navigate = useNavigate();

  const levelSet = [
    { name: "Beginner", tr: "başlangıç" },
    { name: "Intermediate", tr: "orta" },
    { name: "Advanced", tr: "ileri" },
    { name: "Exıt", tr: "cıkış" },
  ];

  const speakingValues = useSelector((state) => state.contents.contentValues);
  const speakingValue = speakingValues?.constents || [];
  useEffect(() => {
    if (completePart) {
      setTaskPackage({
        repeatAdvancedCount: repeatAdvancedCount,
        repeatIntermediateCount: repeatIntermediateCount,
        repeatBeginnerCount: repeatBeginnerCount,
      });
    }
  }, [completePart]);

  // --- END SPEECH RECOGNITION ---

  // Yeni soru/seviyeye geçerken başlangıç durumunu ayarla
  useEffect(() => {
    setIsTeacherTurn(true);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
  }, [TextValue, activeLevel]);

  useEffect(() => {
    if (speakingValue === undefined || speakingValue.length == 0) {
      console.log("İçerik boş, ana sayfaya yönlendiriliyor...");
      navigate("/");
    }
  }, [speakingValue, navigate]);

  // console.log(speakingValues, "gelen değeri ......");

  const getExpectedText = () => {
    const currentItem = speakingValue[TextValue];
    if (activeLevel === "Beginner") {
      return `${currentItem?.EngQuestion || ""} ${
        currentItem?.EngAnswer || ""
      }`.trim();
    } else {
      return currentItem?.EngAnswer || "";
    }
  };

  // Levenshtein Distance algoritması ile benzerlik hesaplama
  const calculateSimilarity = (str1, str2) => {
    const cleanStr1 = str1
      .toLowerCase()
      .trim()
      .replace(/[^\w\s]/g, "");
    const cleanStr2 = str2
      .toLowerCase()
      .trim()
      .replace(/[^\w\s]/g, "");

    const len1 = cleanStr1.length;
    const len2 = cleanStr2.length;

    if (len1 === 0 && len2 === 0) return 1;
    if (len1 === 0 || len2 === 0) return 0;

    const matrix = Array(len1 + 1)
      .fill(null)
      .map(() => Array(len2 + 1).fill(0));

    for (let i = 0; i <= len1; i++) matrix[i][0] = i;
    for (let j = 0; j <= len2; j++) matrix[0][j] = j;

    for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
        const cost = cleanStr1[i - 1] === cleanStr2[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost,
        );
      }
    }

    const distance = matrix[len1][len2];
    const maxLen = Math.max(len1, len2);
    return maxLen === 0 ? 1 : 1 - distance / maxLen;
  };

  // Seviyelere göre benzerlik eşiği
  const getSimilarityThreshold = (level) => {
    switch (level) {
      case "Beginner":
        return 0.6;
      case "Intermediate":
        return 0.7;
      case "Advanced":
        return 0.8;
      default:
        return 0.7;
    }
  };

  // Konuşma tanıma sonucunu değerlendir
  const evaluateSpeech = (spokenText, expectedText) => {
    const similarity = calculateSimilarity(spokenText, expectedText);
    setSimilarityScore(similarity);

    const similarityThreshold = getSimilarityThreshold(activeLevel);
    return similarity >= similarityThreshold;
  };

  // --- SPEECH RECOGNITION (Whisper/Backend Integration) ---
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startListening = async () => {
    // Hoca konuşurken veya zaten dinliyorken başlatma
    if (isSpeaking || isListening) return;

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });
        await sendAudioToBackend(audioBlob);
        // Mikrofonu kapat
        stream.getTracks().forEach((track) => track.stop());
      };

      // UI Reset
      setTranscript("Listening...");
      setIsListening(true);
      setIsCorrect(false);
      setSimilarityScore(0);

      // Sayaç Güncelleme (Hangi seviyedeysek onun sayacını artır)
      const updateCounter = (prev) => ({
        ...prev,
        [TextValue]: (prev[TextValue] || 0) + 1,
      });

      if (activeLevel === "Beginner") setRepeatBeginnerCount(updateCounter);
      if (activeLevel === "Intermediate")
        setRepeatIntermediateCount(updateCounter);
      if (activeLevel === "Advanced") setRepeatAdvancedCount(updateCounter);

      mediaRecorderRef.current.start();

      // 3.5 saniye sonra otomatik durdur (Whisper için ideal süre)
      setTimeout(() => stopListening(), 3500);
    } catch (err) {
      console.error("Microphone access error:", err);
      setTranscript("Mic error!");
      setIsListening(false);
    }
  };

  const stopListening = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
      setIsListening(false);
    }
  };

  const sendAudioToBackend = async (blob) => {
    const formData = new FormData();
    formData.append("audio", blob, "vocal.webm");

    try {
      setTranscript("Analyzing...");
      // const response = await axios.post(
      //   `${import.meta.env.VITE_REACT_APP_SPEECH_URL}speech-to-text`,
      //   formData,
      // );
      const response = await api.post("/transcribe", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        console.log(response.data, "speak");
        const spokenText = response.data.transcript;
        // Beklenen metni mevcut algoritmaya göre alıyoruz
        const expectedText = getExpectedText();

        setTranscript(spokenText);

        const similarity = calculateSimilarity(spokenText, expectedText);
        setSimilarityScore(similarity);

        // Seviyeye göre belirlenmiş threshold'u kullan
        const threshold = getSimilarityThreshold(activeLevel);

        if (similarity >= threshold) {
          setIsCorrect(true);
          // Başarılıysa 1.5 sn sonra otomatik geç
          setTimeout(() => {
            goToNext();
          }, 1500);
        }
      } else {
        setTranscript("Not understood...");
      }
    } catch (error) {
      console.error("Whisper Backend Error:", error);
      setTranscript("Network error...");
    }
  };

  // Asistan konuşması
  const speakText = (text1, text2, activeLevel) => {
    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
      setIsSpeaking(true);

      if (activeLevel === "Beginner") {
        const utterance1 = new SpeechSynthesisUtterance(text1);
        utterance1.lang = "en-US";
        utterance1.rate = 0.9;

        const utterance2 = new SpeechSynthesisUtterance(text2);
        utterance2.lang = "en-US";
        utterance2.rate = 0.9;

        utterance1.onend = () => {
          setTimeout(() => {
            window.speechSynthesis.speak(utterance2);
          }, 30);
        };

        utterance2.onend = () => {
          setIsSpeaking(false);
          setTimeout(() => {
            setIsTeacherTurn(false);
          }, 400);
        };

        window.speechSynthesis.speak(utterance1);
      } else {
        // Intermediate ve Advanced için sadece soruyu söyle
        const utterance = new SpeechSynthesisUtterance(text1);
        utterance.lang = "en-US";
        utterance.rate = 0.9;

        utterance.onend = () => {
          setIsSpeaking(false);
          setTimeout(() => {
            setIsTeacherTurn(false);
          }, 30);
        };

        window.speechSynthesis.speak(utterance);
      }
    }
  };

  // Asistanın konuşacağı metni belirle
  const getAssistantText = () => {
    const currentItem = speakingValue[TextValue];
    if (activeLevel === "Beginner") {
      // Beginner'da hem soru hem cevap
      return {
        text1: currentItem?.EngQuestion || "",
        text2: currentItem?.EngAnswer || "",
      };
    } else {
      // Intermediate ve Advanced'da sadece soru
      return {
        text1: currentItem?.EngQuestion || "",
        text2: "",
      };
    }
  };

  // Sonraki soruya/seviyeye geç
  const goToNext = () => {
    const nextValue = TextValue + 1;
    if (activeLevel === "Advanced") {
      if (nextValue === speakingValue.length) {
        setCompletePart(true);
      }
    }
    if (nextValue < speakingValue.length) {
      setTextValue(nextValue);
    } else {
      if (activeLevel === "Beginner") {
        setActiveLevel("Intermediate");
      } else if (activeLevel === "Intermediate") {
        setActiveLevel("Advanced");
      }
      setTextValue(0);
    }
  };

  // Manuel "Next" butonu
  const handleNextButton = () => {
    goToNext();
  };

  const goToBack = () => {
    const currentText = TextValue;
    // En başta mı kontrol et
    if (
      currentText === -1 &&
      currentStage === -1 &&
      activeLevel === "Beginner"
    ) {
      console.log("0");
      return;
    }
    const nextValue = currentText - 1;
    if (activeLevel === "Advanced") {
      setTextValue(speakingValue.length - 1);
      if (nextValue < 0) {
        console.log("1");
        setActiveLevel("Intermediate");
      }
      if (nextValue === speakingValue.length) {
        console.log("2");
        return;
      }
    }
    if (nextValue >= 0) {
      // Aynı stage içinde geri git
      setTextValue(nextValue);
    } else {
      // Seviye değiştirme gerekiyor
      if (activeLevel === "Advanced") {
        setActiveLevel("Intermediate");
        setTextValue(speakingValue.length - 1);
      } else if (activeLevel === "Intermediate") {
        setActiveLevel("Beginner");
        setTextValue(speakingValue.length - 1);
      }
    }
  };

  const handleBackButton = () => {
    goToBack();
  };

  // Seviye değiştiğinde reset
  const handleLevelChange = (level) => {
    if (level === "Exıt") {
      navigate("/");
      return;
    }
    setActiveLevel(level);
    setTextValue(0);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
  };

  // Benzerlik skoruna göre renk belirle
  const getSimilarityColor = (score) => {
    if (score >= 0.8) return "text-green-600";
    if (score >= 0.6) return "text-yellow-600";
    return "text-red-600";
  };

  // Benzerlik skoruna göre feedback mesajı
  const getFeedbackMessage = (score) => {
    if (score >= 0.9) return "Mükemmel! 🎉";
    if (score >= 0.8) return "Çok iyi! 👍";
    if (score >= 0.7) return "İyi! 👏";
    if (score >= 0.6) return "Fena değil! 😊";
    return "Tekrar deneyin! 🔄";
  };

  // Beklenen metni gösterim için formatla
  const getDisplayExpectedText = () => {
    return getExpectedText();
  };

  return (
    <div
      className=" flex flex-col w-full gap-4"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      {/* celebrate */}
      <div className={`${completePart ? "block" : "hidden"} `}>
        {completePart ? (
          <CelebrationComponent
            setCompletePart={setCompletePart}
            taskPackage={taskPackage}
          />
        ) : null}
      </div>
      {/* speaknig */}
      <div
        className={`${completePart ? "hidden" : "block"}  flex flex-col  gap-4 w-full `}
      >
        {/* Header */}
        <div className="w-full">
          <HeaderCard
            handleLevelChange={handleLevelChange}
            levelSet={levelSet}
            activeLevel={activeLevel}
          />
        </div>
        {/* contents (icerilker) */}
        <div className="w-full flex flex-col bg-purple-500 rounded-xl p-2 gap-4 ">
          <div>
            <div className="flex justify-between items-center  ">
              <BackButton handleBackButton={handleBackButton} />

              <ArrayCounter TextValue={TextValue} />

              <NextButton handleNextButton={handleNextButton} />
            </div>

            {/* Görsel içerik */}
            <div
              className="w-full bg-gradient-to-br from-purple-500 to-purple-500
            py-3 md:py-10 flex justify-center items-center flex-row gap-3 md:gap-8"
            >
              <div className="flex flex-col justify-center items-center md:flex-row gap-6 md:gap-8">
                {/* Beginner: Hem İngilizce hem Türkçe göster */}
                {activeLevel === "Beginner" && (
                  <div className="flex gap-3 items-center flex-col lg:flex-row">
                    <div className="text-6xl lg:text-9xl drop-shadow-lg">
                      {speakingValue[TextValue]?.emoji}
                    </div>
                    <div
                      className="bg-white rounded-2xl p-4 lg:p-6 shadow-xl
                   hover:shadow-2xl transition-all w-full md:w-auto border-yellow-400 border-l-6"
                    >
                      <div className="space-y-3">
                        <div>
                          <span
                            className="inline-block px-3 py-1 bg-purple-100
                         text-purple-700 font-semibold rounded-lg text-md md:text-lg mb-2"
                          >
                            English
                          </span>
                          <div className="flex flex-col lg:flex-row gap-2">
                            <p className="text-md md:text-lg text-gray-700 leading-relaxed">
                              ❓ {speakingValue[TextValue]?.EngQuestion}
                            </p>
                            <p className="text-md lg:text-lg text-gray-700 leading-relaxed">
                              ✋ {speakingValue[TextValue]?.EngAnswer}
                            </p>
                          </div>
                        </div>
                        <div>
                          <span
                            className="inline-block px-3 py-1 bg-green-100 text-green-700
                        font-semibold rounded-lg text-md lg:text-lg mb-2"
                          >
                            Türkçe
                          </span>
                          <div className="flex flex-col lg:flex-row gap-2">
                            <p className="text-md lg:text-lg text-gray-700 leading-relaxed">
                              ❓ {speakingValue[TextValue]?.trQuestion}
                            </p>
                            <p className="text-md lg:text-lg text-gray-700 leading-relaxed">
                              ✋ {speakingValue[TextValue]?.trAnswer}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Intermediate: Sadece İngilizce göster */}
                {activeLevel === "Intermediate" && (
                  <div className="flex flex-col lg:flex-row gap-2 items-center">
                    <div
                      className="bg-white rounded-2xl p-4 lg:p-6 shadow-xl
                   hover:shadow-2xl transition-all w-full lg:w-auto border-yellow-400 border-l-6"
                    >
                      <div>
                        <span
                          className="inline-block px-3 py-1 bg-purple-100
                       text-purple-700 font-semibold rounded-lg text-md md:text-lg mb-2"
                        >
                          English Question
                        </span>
                        <p className="text-md lg:text-lg text-gray-700 leading-relaxed">
                          {speakingValue[TextValue]?.EngQuestion}
                        </p>
                      </div>
                    </div>
                    <div className="text-6xl lg:text-9xl drop-shadow-lg">
                      {speakingValue[TextValue]?.emoji}
                    </div>
                    <div
                      className="bg-white rounded-2xl p-4 md:p-6 shadow-xl
                   hover:shadow-2xl transition-all w-full lg:w-auto border-yellow-400 border-l-6"
                    >
                      <div>
                        <span
                          className="inline-block px-3 py-1 bg-purple-100
                       text-purple-700 font-semibold rounded-lg text-md lg:text-lg mb-2"
                        >
                          English Answer
                        </span>
                        <p className="text-md lg:text-lg text-gray-700 leading-relaxed">
                          {speakingValue[TextValue]?.EngAnswer}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Advanced: Sadece emoji göster */}
                {activeLevel === "Advanced" && (
                  <div className="flex flex-col items-center gap-4">
                    <div className="text-8xl md:text-9xl drop-shadow-lg">
                      {speakingValue[TextValue]?.emoji}
                    </div>
                    <div className="text-center">
                      <p className="text-white text-lg font-semibold">
                        Sadece emojiyi görüyorsunuz. Cevabınızı söyleyin!
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Konuşma kartları */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 w-full">
            <div
              className={`${
                isTeacherTurn ? "bg-yellow-500" : "bg-gray-200"
              } rounded-2xl p-4 md:p-6 shadow-xl border-l-4 ${
                isTeacherTurn ? "border-purple-500" : "border-gray-400"
              } hover:shadow-2xl transition-all`}
            >
              <div
                className="flex flex-col sm:flex-row items-start
             sm:items-center justify-between gap-3 mb-4"
              >
                <div className=" hidden sm:flex  items-center gap-2">
                  <span className="text-xl md:text-3xl">🤖</span>
                  <div className="flex flex-col ">
                    <p
                      className={`text-lg md:text-xl font-bold ${
                        isTeacherTurn ? "text-gray-800" : "text-gray-500"
                      }`}
                    >
                      Your Assistant
                    </p>
                    <hr className="border-b-2 border-purple-500" />
                    <p>Senin Asistanın</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    const assistantText = getAssistantText();
                    speakText(
                      assistantText.text1,
                      assistantText.text2,
                      activeLevel,
                    );
                  }}
                  disabled={!isTeacherTurn || isSpeaking}
                  className={`px-6 py-3 font-semibold rounded-lg shadow-md
                  transition-all flex items-center gap-2 text-sm md:text-base
                  w-full sm:w-auto justify-center ${
                    isTeacherTurn && !isSpeaking
                      ? "bg-purple-500 hover:bg-purple-600 text-white"
                      : "bg-gray-400 text-gray-100 cursor-not-allowed"
                  }`}
                >
                  <span className="text-3xl">🔊</span>
                  <div className="flex flex-col">
                    <p> {isSpeaking ? "Listening..." : "Listen"}</p>
                    <hr className="border-b-2 border-yellow-500" />
                    <p> {isSpeaking ? "Dinleniliyor..." : "Dinlemi"}</p>
                  </div>
                </button>
              </div>
            </div>

            {/* Öğrenci Kartı - Tüm seviyelerde */}
            <div
              className={`${
                isTeacherTurn ? "bg-gray-200" : "bg-yellow-500"
              } rounded-2xl p-4 md:p-6 shadow-xl border-l-4 ${
                isTeacherTurn ? "border-gray-400" : "border-purple-500"
              } hover:shadow-2xl transition-all`}
            >
              <div
                className="flex flex-col sm:flex-row items-start sm:items-center
                  justify-between gap-3 mb-4"
              >
                <div className="sm:flex  items-center gap-2 hidden">
                  <span className="text-xl md:text-3xl">👨‍🎓</span>
                  <div className="flex flex-col">
                    <p
                      className={`text-lg md:text-xl font-bold ${
                        isTeacherTurn ? "text-gray-500 " : "text-gray-800"
                      }`}
                    >
                      Student (You)
                    </p>
                    <hr className="border-b-2 border-purple-500" />
                    <p>Öğrenci(siz)</p>
                  </div>
                </div>
                <button
                  onClick={startListening}
                  disabled={isTeacherTurn || isListening}
                  className={`px-6 py-3 font-semibold rounded-lg shadow-md
            transition-all flex items-center gap-2 text-sm md:text-base
              w-full sm:w-auto justify-center ${
                !isTeacherTurn && !isListening
                  ? "bg-purple-500 hover:bg-purple-600 text-white"
                  : "bg-gray-400 text-gray-100 cursor-not-allowed"
              }`}
                >
                  <span className="text-3xl">🎤</span>
                  <div className="flex flex-col">
                    <p> {isListening ? "Listening..." : "Speak"}</p>
                    <hr className="border-b-2 border-yellow-500" />
                    <p className="text-sm font-normal">
                      {isListening ? "konuşuluyor..." : "konuşma"}
                    </p>
                  </div>
                </button>
              </div>

              {transcript && (
                <div
                  className={`mt-4 p-3 border-l-4 rounded ${
                    isCorrect
                      ? "bg-green-50 border-green-500"
                      : "bg-yellow-50 border-yellow-500"
                  }`}
                >
                  <p
                    className={`text-sm font-semibold ${
                      isCorrect ? "text-green-700" : "text-yellow-700"
                    }`}
                  >
                    {isCorrect
                      ? "Doğru! 🎉 (Otomatik geçiliyor...)"
                      : "You said:"}
                  </p>
                  <p className="text-gray-800">{transcript}</p>

                  {/* Benzerlik skoru gösterimi */}
                  {similarityScore > 0 && (
                    <div className="mt-2 p-2 bg-blue-50 rounded-lg">
                      <div className="flex justify-between items-center">
                        {/* <span className="text-xs text-blue-700 font-medium">
                  Benzerlik Skoru:
                </span> */}
                        <span
                          className={`text-sm font-bold ${getSimilarityColor(
                            similarityScore,
                          )}`}
                        >
                          {(similarityScore * 100).toFixed(1)}%
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                        <div
                          className={`h-2 rounded-full ${
                            similarityScore >= 0.8
                              ? "bg-green-500"
                              : similarityScore >= 0.6
                                ? "bg-yellow-500"
                                : "bg-red-500"
                          }`}
                          style={{ width: `${similarityScore * 100}%` }}
                        ></div>
                      </div>
                      {/* <p className="text-xs text-blue-600 mt-1">
                {getFeedbackMessage(similarityScore)}
              </p> */}
                    </div>
                  )}

                  {!isCorrect && (
                    <p className="text-xs text-gray-500 mt-1">
                      Beklenen: {getDisplayExpectedText()}
                    </p>
                  )}
                </div>
              )}

              {!transcript && !isTeacherTurn && (
                <div className="text-sm text-gray-600 mt-2">
                  {activeLevel === "Advanced"
                    ? "Emojiye bakarak cevabınızı söyleyin"
                    : "Mikrofon butonuna basarak konuşun"}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Speaking_1;
